import React, { forwardRef } from "react";
import { m } from 'framer-motion';

import Link from '../Atoms/Link';
import { ArrowDown } from "../Atoms/ArrowButton";
import { BUYING_INDEX_ROUTE, SELLING_INDEX_ROUTE } from "../../utils/routes/const";


const ANIMATION_DURATION = 3;

const WelcomeText = forwardRef(
  (
    { scrollDown, t }: { scrollDown: () => void, t: (string: string) => string },
    ref: React.Ref<HTMLDivElement>
  ) => (
    <div data-scroll-section className="h-3/5 lg:h-screen overflow-hidden will-change-opacity" ref={ref}>
      <m.div
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
          transition: {
            duration: ANIMATION_DURATION,
          }
        }}
        className="py-16 lg:py-36 flex flex-col items-center justify-center text-center"
        style={{ scrollSnapAlign: 'start' }}
      >
        <span className="text-xl font-cirka mb-6">{t('hero.welcome')}</span>
        <h1 className="font-cirka text-5xl lg:text-8xl text-primary max-w-3xl">
          {t('hero.title.beginningEstimate')}
          <Link className="text-blue" to={SELLING_INDEX_ROUTE}>{t('hero.title.estimate')}</Link>
          {t('hero.title.or')}
          <Link className="text-blue" to={BUYING_INDEX_ROUTE}>{t('hero.title.buy')}</Link>
          {t('hero.title.ending')}
        </h1>
        <ArrowDown className="mt-10" onClick={scrollDown} />
      </m.div>
    </div>
  ));

export default WelcomeText;
